import {documentLoadEvent} from "../../../../webpack/modules/events";

documentLoadEvent(function() {
    initScrollers(document);
    observeNewScrollers();
});

function observeNewScrollers()
{
    let container = document.querySelector('#product-list-page');
    if (!container || !('MutationObserver' in window)) return;

    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                initScrollers(node);
            });
        });
    });

    observer.observe(container, {childList: true, subtree: true});
}

function initScrollers(root)
{
    let scrollers = root.matches && root.matches('.semi-home-page-block__scroller')
        ? [root]
        : root.querySelectorAll('.semi-home-page-block__scroller');

    scrollers.forEach(function(scroller) {
        if (scroller.dataset.sliderInitialized) return;
        scroller.dataset.sliderInitialized = 'true';
        initScroller(scroller);
    });
}

function initScroller(scroller)
{
    let row = scroller.querySelector('.semi-home-page-block__items');
    let prev = scroller.querySelector('.semi-home-page-block__nav--prev');
    let next = scroller.querySelector('.semi-home-page-block__nav--next');
    let scrollbar = scroller.querySelector('.semi-home-page-block__scrollbar');
    let scrollbarThumb = scroller.querySelector('.semi-home-page-block__scrollbar-thumb');

    if (!row || !prev || !next) return;

    function refresh()
    {
        let max = row.scrollWidth - row.clientWidth - 1;
        let isScrollable = max > 0;

        prev.hidden = !isScrollable || row.scrollLeft <= 1;
        next.hidden = !isScrollable || row.scrollLeft >= max;

        if (scrollbar && scrollbarThumb) {
            scrollbar.hidden = !isScrollable;

            if (isScrollable) {
                let thumbWidthPercent = Math.min(100, (row.clientWidth / row.scrollWidth) * 100);
                let progress = row.scrollLeft / max;

                scrollbarThumb.style.width = thumbWidthPercent + '%';
                scrollbarThumb.style.left = (progress * (100 - thumbWidthPercent)) + '%';
            }
        }
    }

    function scrollByDirection(direction)
    {
        let item = row.querySelector('.semi-home-page-block__item');
        let amount = (item ? item.getBoundingClientRect().width : row.clientWidth) + 12;

        row.scrollBy({left: direction * amount * 2, behavior: 'smooth'});
    }

    prev.addEventListener('click', function() {
        scrollByDirection(-1);
    });

    next.addEventListener('click', function() {
        scrollByDirection(1);
    });

    row.addEventListener('scroll', refresh, {passive: true});
    window.addEventListener('resize', refresh);

    if (scrollbar && scrollbarThumb) {
        let isDraggingScrollbar = false;

        function scrollToPointerPosition(event)
        {
            let trackRect = scrollbar.getBoundingClientRect();
            let ratio = (event.clientX - trackRect.left) / trackRect.width;
            let max = row.scrollWidth - row.clientWidth;

            row.scrollLeft = Math.max(0, Math.min(max, ratio * max));
        }

        scrollbar.addEventListener('pointerdown', function(event) {
            isDraggingScrollbar = true;
            scrollbar.setPointerCapture(event.pointerId);
            scrollToPointerPosition(event);
        });

        scrollbar.addEventListener('pointermove', function(event) {
            if (!isDraggingScrollbar) return;
            scrollToPointerPosition(event);
        });

        let stopDraggingScrollbar = function() {
            isDraggingScrollbar = false;
        };

        scrollbar.addEventListener('pointerup', stopDraggingScrollbar);
        scrollbar.addEventListener('pointercancel', stopDraggingScrollbar);
    }

    // Touch devices already scroll natively via overflow-x; drag-to-scroll is only wired for mouse
    // so a plain tap on a card link is never hijacked (setPointerCapture would retarget its click).
    let isPointerDown = false;
    let hasDragged = false;
    let startX = 0;
    let startScrollLeft = 0;
    let activePointerId = null;

    function onPointerMove(event)
    {
        if (!isPointerDown || event.pointerId !== activePointerId) return;
        let deltaX = event.clientX - startX;
        if (Math.abs(deltaX) > 4) hasDragged = true;
        row.scrollLeft = startScrollLeft - deltaX;
    }

    function onPointerUp(event)
    {
        if (event.pointerId !== activePointerId) return;
        isPointerDown = false;
        activePointerId = null;
        window.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('pointerup', onPointerUp);
    }

    row.addEventListener('pointerdown', function(event) {
        if (event.pointerType !== 'mouse') return;
        isPointerDown = true;
        hasDragged = false;
        startX = event.clientX;
        startScrollLeft = row.scrollLeft;
        activePointerId = event.pointerId;
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
    });

    row.addEventListener('click', function(event) {
        if (hasDragged) event.preventDefault();
    }, true);

    setTimeout(refresh, 60);
}